/**
 * The empty array to return when there is nothing to return.
 *
 * `[]` written inline is a new array every render, so a hook that
 * falls back to one hands its caller a fresh reference each time. Put
 * that in a dependency array and every render looks like a change,
 * which re-runs the effect, which renders again. Returning this
 * instead keeps the reference stable, so nothing downstream sees a
 * change that did not happen.
 *
 * Read-only on purpose: one array shared by every caller must not be
 * something any of them can write to. Cast it where a mutable type is
 * genuinely needed — and look again first, because it usually is not.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([])
